export enum OtherObstructionType {
  Billboard,
  CrepeWithInsulation,
  Sunshade,
  Terrace,
  Lighting,
  Other,
}
